module.exports = __webpack_public_path__ + "img/loudspeaker.e9315d30.png";